// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assest/Svg/LGIMG1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assest/Svg/LGIMG2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../Assest/Svg/LGIMG3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../Assest/Svg/LGIMG4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../Assest/Svg/LGIMG5.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../Assest/Svg/LGTittle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_thUQh {
  height: 100vh;
  margin: -8px;
  overflow: hidden;
}
.loginPage_MTeNd {
  background: linear-gradient(145deg, #306bff 25%, #f3bf57, #abff8d);
}
.loginTittleContainter_ufA9D {
  margin-bottom: 30px;
}
.loginTittle_xcZyj {
  text-align: center;
  font-weight: 600;
  font-size: 32px;
  line-height: 38.73px;
  height: 53px;
}
.loginTittleDesc_cNmhx {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 20.16px;
  color: #718096;
  height: 20px;
}
.loginContent_ECPLl {
  height: 60%;
  padding-left: 22%;
  padding-right: 22%;
  margin-top: 16%;
}
.loginFormButton_q728B {
  width: 100%;
}
.backButton_Vg7lC {
  margin-top: 20px;
  width: 100%;
}
.loginFormForgot_ask9U {
  float: right;
}
.doNotHaveAccountText_I8dMt {
  text-align: center;
  margin-top: 14%;
  color: #748094;
  font-weight: 400;
  font-size: 16px;
}
.powerdByText_h2dGN {
  text-align: center;
  margin-top: 14%;
  color: #748094;
  font-weight: 400;
  font-size: 14px;
}
.backgroundImage_nfCFC {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat fixed bottom left, url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 70% 100%, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 104% 60%, url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat 110% 0%, url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat 110% 0%, url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat 30% 25%;
  height: 100%;
}
.overlay_KQPpP {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/User/login.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAEA;EACI,kEAAA;AAAJ;AAGA;EACI,mBAAA;AADJ;AAIA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AAFJ;AAKA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;AAHJ;AAMA;EAEI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AALJ;AAQA;EACI,WAAA;AANJ;AASA;EACI,gBAAA;EACA,WAAA;AAPJ;AAUA;EACI,YAAA;AARJ;AAWA;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AATJ;AAYA;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAVJ;AAaA;EACI,wXAAA;EAOA,YAAA;AAjBJ;AAoBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAlBJ","sourcesContent":[".main {\n    height: 100vh;\n    margin: -8px;\n    overflow: hidden;\n}\n\n.loginPage {\n    background: linear-gradient(145deg, #306bff 25%, #f3bf57, #abff8d);\n}\n\n.loginTittleContainter {\n    margin-bottom: 30px;\n}\n\n.loginTittle {\n    text-align: center;\n    font-weight: 600;\n    font-size: 32px;\n    line-height: 38.73px;\n    height: 53px;\n}\n\n.loginTittleDesc {\n    text-align: center;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20.16px;\n    color: #718096;\n    height: 20px;\n}\n\n.loginContent {\n    // background-color: red;\n    height: 60%;\n    padding-left: 22%;\n    padding-right: 22%;\n    margin-top: 16%;\n}\n\n.loginFormButton {\n    width: 100%;\n}\n\n.backButton {\n    margin-top: 20px;\n    width: 100%;\n}\n\n.loginFormForgot {\n    float: right;\n}\n\n.doNotHaveAccountText {\n    text-align: center;\n    margin-top: 14%;\n    color: #748094;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.powerdByText {\n    text-align: center;\n    margin-top: 14%;\n    color: #748094;\n    font-weight: 400;\n    font-size: 14px;\n}\n\n.backgroundImage {\n    background:\n        url('../../Assest/Svg/LGIMG1.svg') no-repeat fixed bottom left,\n        url('../../Assest/Svg/LGIMG2.svg') no-repeat 70% 100%,\n        url('../../Assest/Svg/LGIMG3.svg') no-repeat 104% 60%,\n        url('../../Assest/Svg/LGIMG4.svg') no-repeat 110% 0%,\n        url('../../Assest/Svg/LGIMG5.svg') no-repeat 110% 0%,\n        url('../../Assest/Svg/LGTittle.svg') no-repeat 30% 25%;\n    height: 100%;\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `main_thUQh`,
	"loginPage": `loginPage_MTeNd`,
	"loginTittleContainter": `loginTittleContainter_ufA9D`,
	"loginTittle": `loginTittle_xcZyj`,
	"loginTittleDesc": `loginTittleDesc_cNmhx`,
	"loginContent": `loginContent_ECPLl`,
	"loginFormButton": `loginFormButton_q728B`,
	"backButton": `backButton_Vg7lC`,
	"loginFormForgot": `loginFormForgot_ask9U`,
	"doNotHaveAccountText": `doNotHaveAccountText_I8dMt`,
	"powerdByText": `powerdByText_h2dGN`,
	"backgroundImage": `backgroundImage_nfCFC`,
	"overlay": `overlay_KQPpP`
};
export default ___CSS_LOADER_EXPORT___;
